import { Store } from "./IStore";
import {
    IStore,
    IStoreSales,
    IStoreWorkflowComment,
    IWordCloudItem,
} from "./Models";

export interface IStoreExploreData {
  store: IStore;
  files: Array<File> /* List */;
  lifecycleComments: Array<IStoreWorkflowComment> /* List */;
  segmentFeatures: Array<IWordCloudItem> /* List */;
  countsBySegment: any /* Dictionary */;
  countsByHouseholdType: any /* Dictionary */;
  storeSales: Array<IStoreSales> /* List */;
  storeSalesGrouped: Array<number> /* List */;
  salesBySegment: any /* Dictionary */;
  salesRank: number;
  totalHouseholds: number;
  storeSalesGroupedTopThree: Array<number>;
  averageCompanyHouseholds: number;
  modelName: string;
}

export class StoreExploreData implements IStoreExploreData {
  public store = new Store();
  public files = [];
  public lifecycleComments = [];
  public segmentFeatures = [];
  public countsBySegment = 0;
  public countsByHouseholdType = {};
  public storeSales = [];
  public storeSalesGrouped = [];
  public storeSalesGroupedTopThree = [];
  public salesBySegment = 0;
  public salesRank = 0;
  public totalHouseholds = 0;
  public averageCompanyHouseholds = 0;
  public modelName = "";
}
